module.exports = __webpack_public_path__ + "static/media/start-tour.29175b8a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/start-tour.svg
// module id = 1389
// module chunks = 0